module.exports = __webpack_public_path__ + "img/yancheng.67d4ee41.png";